import { Injectable, Optional, Host } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Observable ,  of } from "rxjs";

import { DataQuery, DataParameter, DataResult, DatabaseType } from "../models/query.model";
import { FlowComponent } from "../../flow/components/flow/flow.component";
import { BaseControlComponent } from "../../form-controls/components/base-control/base-control.component";
import { deepClone } from "../../builder/models/editor.model";

@Injectable()
export class QueryService {
    static readonly BaseUrl = "api/query";


    constructor(
        public http: HttpClient
    ) {
    }

    getAll(): Observable<DataQuery[]> {
        return this.http.get<DataQuery[]>(`${QueryService.BaseUrl}/getAll`);
    }

    getByName(name: string): Observable<DataQuery> {
        return this.http.get<DataQuery>(`${QueryService.BaseUrl}/getByName/${name}`);
    }

    runQuery(query: DataQuery, component?: BaseControlComponent): Observable<any> {
        if (query.id === '-1')
            return;

        let copy: DataQuery = deepClone(query);

        if (component) {
            for (let param of copy.parameters) {
                switch (param.source) {
                    case "loggedInUser":
                        if (component.flowComponent && component.flowComponent.workflow)
                            param.value = component.flowComponent.workflow.userId;
                        break;
                    case "loggedInOrganization":
                        if (component.flowComponent && component.flowComponent.workflow)
                            param.value = component.flowComponent.workflow.organizationId;
                        break;
                    case "currentDate":
                        //do nothing, will be populated by the back-end
                        break;
                    default:
                        if (param.value.toString().indexOf("$.") !== -1) {
                            let data = component.getContextData(param.value);
                            param.value = data;

                            if (copy.database === DatabaseType.Context)
                                return of(data);
                        }
                        break;
                }
            }
        }

        return this.http.post<any>(`${QueryService.BaseUrl}/runQuery`, copy);
    }
}
